// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"ae82446b","167":"4eaa10a5","190":"b2d0fc5a","726":"8949fc63"}[chunkId] + ".chunk.js";
};